export default {
    'OPERACION_DEPENDENCIA': (state, mutation) => {
        state.dependencia = mutation.dependencia
    }
}